import { FetchResponse, FetchSuccess } from "../types";
import {
  DefaultFetchError,
  FetchCreate,
  FetchGetId,
  FetchUpdate,
  useFetchCreate,
  useFetchGetId,
  useFetchUpdate,
} from './fetch';

export interface ILoansClosingCosts {
  id: number;
  loanId: number;
  text: string;
  name: string;
  type: string;
  amount: number;
  createdAt: string;
  updatedAt: string;
}

export const useLoansClosingCostsId = (): FetchGetId<FetchResponse<ILoansClosingCosts>> =>
  useFetchGetId('loans/report-closing-costs', '', {
    autoStart: false,
    startStateLoading: false,
    multiple: 'loansClosingCosts'
  });

export const useUpdateLoansClosingCostAmount = (): FetchUpdate<FetchSuccess, DefaultFetchError, { amount: number }> =>
  useFetchUpdate('loans/closing-cost/amount', '');

export const useReportFileUploadMismo = (): FetchCreate<FetchResponse<string>, DefaultFetchError, FormData> =>
  useFetchCreate('loans/upload-mismo');
